export const mapRogoDevSubTypeToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const rogoDevSubTypeColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "devSubTypeCode", label: "DevSubTypeCode", align: "center" },
  { key: "devSubTypeStr", label: "DevSubTypeStr", align: "center" },
];
